import React, { createElement, useEffect, useState, Fragment, useRef } from 'react';
import { formatImage } from '@ifeng/public_method';
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask';
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip';
import Chip from 'Chip';
import md5 from 'md5';
import Style from './index.module.scss';
import Video from './Video';
import { Swiper } from 'swiper/esm/react/swiper.js';
import { SwiperSlide } from 'swiper/esm/react/swiper-slide.js';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.scss';
import listLeft from './assets/S_left.png';
import listLeftHover from './assets/S_left_click.png';
import listRight from './assets/S_right.png';
import listRightHover from './assets/S_right_click.png';
import videoLeft from './assets/B_left.png';
import videoLeftHover from './assets/B_left_click.png';
import videoRight from './assets/B_right.png';
import videoRightHover from './assets/B_right_click.png';

SwiperCore.use([Navigation]);

export interface VideoList_cjck_Props {
    chip: TYPE_Chip;
    style?: object;
    __designMode: string;
}

const VideoList_cjck: React.FC<VideoList_cjck_Props> = (props) => {
    const { chip, style, __designMode } = props;
    const chipData = useChip(chip) ?? [];
    const chipProps = formatChip(chip);
    const [playIndex, setPlayIndex] = useState(-1);

    const swiperRef = useRef();

    useEffect(() => {
        if (Array.isArray(chipData) && chipData.length) {
            setPlayIndex(chipData.findIndex((item) => item.showVideo));
        }
    }, [chipData]);

    const getHash = () => {
        return md5(JSON.stringify({ chip, playIndex }));
    };

    const [isVideoHoverLeft, setIsVideoHoverLeft] = useState(false);
    const [isVideoHoverRight, setIsVideoHoverRight] = useState(false);
    const [isHoverLeft, setIsHoverLeft] = useState(false);
    const [isHoverRight, setIsHoverRight] = useState(false);

    const handlePrevClick = () => {
        // @ts-ignore
        swiperRef.current.slidePrev();
        setPlayIndex(playIndex - 1 < 0 ? chipData.length - 1 : playIndex - 1);
    };

    const handleNextClick = () => {
        // @ts-ignore
        swiperRef.current.slideNext();
        setPlayIndex(playIndex + 1 > chipData.length - 1 ? 0 : playIndex + 1);
    };

    return (
        <Chip {...chipProps}>
            <div className={Style.wrap} style={style}>
                <div className={Style.videoWrap}>
                    {chipData[playIndex] ? (
                        <Fragment>
                            <Video content={chipData[playIndex]} key={getHash()} />
                            <div
                                className={Style.videoPrevBtn}
                                onMouseEnter={() => setIsVideoHoverLeft(true)}
                                onMouseLeave={() => setIsVideoHoverLeft(false)}
                                onClick={handlePrevClick}
                            >
                                <img src={isVideoHoverLeft ? videoLeftHover : videoLeft} alt="" />
                            </div>
                            <div
                                className={Style.videoNextBtn}
                                onMouseEnter={() => setIsVideoHoverRight(true)}
                                onMouseLeave={() => setIsVideoHoverRight(false)}
                                onClick={handleNextClick}
                            >
                                <img
                                    src={isVideoHoverRight ? videoRightHover : videoRight}
                                    alt=""
                                />
                            </div>
                        </Fragment>
                    ) : null}
                </div>
                <div className={Style.videoListWrap}>
                    {Array.isArray(chipData) && chipData.length ? (
                        <Swiper
                            initialSlide={0}
                            loop={true}
                            slidesPerView={4}
                            simulateTouch={__designMode !== 'design'}
                            onSwiper={(swiper) => {
                                swiperRef.current = swiper;
                            }}
                        >
                            {chipData.map((item, index) => {
                                const {
                                    title,
                                    thumbnailShowVideo,
                                    thumbnailNotShowVideo,
                                    showVideo,
                                } = item;
                                const isCurrent = index === playIndex;
                                const poster = showVideo
                                    ? thumbnailShowVideo
                                    : thumbnailNotShowVideo;

                                return (
                                    <SwiperSlide key={index}>
                                        <div
                                            className={Style.videoListItem}
                                            onClick={() => {
                                                if (!isCurrent) {
                                                    setPlayIndex(index);
                                                }
                                            }}
                                        >
                                            <div className={Style.itemThumbnail}>
                                                <img
                                                    src={formatImage(poster, 273, 138) || poster}
                                                    alt={title}
                                                />
                                                <Fragment>
                                                    {isCurrent ? (
                                                        <div
                                                            className={Style.itemMaskCurrent}
                                                        ></div>
                                                    ) : (
                                                        <div className={Style.itemMask}></div>
                                                    )}
                                                </Fragment>
                                            </div>
                                            {title ? (
                                                <div className={Style.itemTitle}>{title}</div>
                                            ) : null}
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    ) : null}

                    <div
                        className={Style.prevBtn}
                        onClick={handlePrevClick}
                        onMouseEnter={() => setIsHoverLeft(true)}
                        onMouseLeave={() => setIsHoverLeft(false)}
                    >
                        <img src={isHoverLeft ? listLeftHover : listLeft} alt="prev" />
                    </div>
                    <div
                        className={Style.nextBtn}
                        onClick={handleNextClick}
                        onMouseEnter={() => setIsHoverRight(true)}
                        onMouseLeave={() => setIsHoverRight(false)}
                    >
                        <img src={isHoverRight ? listRightHover : listRight} alt="next" />
                    </div>
                </div>
                <Mask visible={!chip.id} zIndex={3}>
                    示例结构化碎片—{chip.default.id}
                </Mask>
            </div>
        </Chip>
    );
};

export default VideoList_cjck;
